import { library } from '@fortawesome/fontawesome-svg-core';
import { faSearch, faHome, faShoppingBasket, faCartPlus, faShoppingCart, faTrashAlt } from '@fortawesome/free-solid-svg-icons';


library.add(
    faHome,
    faSearch,
    faShoppingBasket,
    faCartPlus,
    faShoppingCart,
    faTrashAlt
);